import { BrowserContext2d } from "../browser";

export class WxContext2d extends BrowserContext2d {
    draw() {}
    createPattern(image, repetition) {
        return null;
    }
}

WxContext2d.env = "wx";
//# sourceMappingURL=context.js.map
